import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { preferenciasGridApi } from '../api/preferenciasGrid';

/**
 * Carrega a preferência do usuário para uma grid específica.
 * Retorna null se nunca foi salvo (primeiro acesso) — front aplica defaults.
 */
export function usePreferenciaGrid(gridId: string) {
  return useQuery({
    queryKey: ['preferencias-grid', gridId],
    queryFn: () => preferenciasGridApi.obter(gridId),
    staleTime: Infinity, // Só re-busca em invalidação manual
    retry: 1,
  });
}

export function useSalvarPreferenciaGrid(gridId: string) {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (estadoJson: string) => preferenciasGridApi.salvar(gridId, estadoJson),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['preferencias-grid', gridId] });
    },
  });
}
